import React from "react";
import { PictureContainer, ImageWrap, WorkTitle } from "./styled";
import Image from "next/image";
import pics from "../../../data/_careersPics";

function index() {
  return (
    <>
      <WorkTitle>
        {" "}
        <span>What We Design, Build & Install</span>{" "}
      </WorkTitle>
      <PictureContainer>
        {pics.map((pic) => {
          return (
            <ImageWrap key={pic.src}>
              <Image
                src={pic.src}
                alt="sample of work we have done"
                objectFit="cover"
                layout="fill"
                className="pic"
                quality={50}
              />
            </ImageWrap>
          );
        })}
      </PictureContainer>
    </>
  );
}

export default index;
